import React, { useState, useEffect } from "react";
import styles from "./FiltersAndSorting.module.css";

const FiltersAndSorting = (props) => {
    const { isVisible, toggleIsVisible } = props

    // Open modal and push state
    const handleOpen = () => {
        // toggleIsVisible(true);
        window.history.pushState({ modalOpen: true }, ""); // Push a state
        document.body.style.overflowY = "hidden";

    };

    useEffect(() => {
        if(isVisible) {
            handleOpen()
        }
    }, [isVisible])
    
    // Close modal and revert state
    const handleClose = () => {
        toggleIsVisible(false);
        if (window.history.state?.modalOpen) {
            window.history.back(); // Revert to the previous state
            document.body.style.overflowY = "auto";
        }
    };

    useEffect(() => {
        const handleBackButton = () => {
            if (isVisible) {
                toggleIsVisible(false);
                document.body.style.overflowY = "auto";
                return;
            }
        };

        // Add listener for popstate when modal is visible
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [isVisible]);

    return (
        <>
            {isVisible && (
                <div className={styles.overlay} onClick={() => handleClose()}>
                    <div
                        className={styles.content}
                        onClick={(e) => e.stopPropagation()} // Prevent closing on inner content click
                    >
                        <button className={styles.closeButton} onClick={() => handleClose()}>
                            &times;
                        </button>
                        <h2>Filters & Sorting</h2>
                        <div className={styles.filters}>
                            <div className={styles.filterItem}>
                                <label>Sort By</label>
                                <select>
                                    <option>Price: Low to High</option>
                                    <option>Price: High to Low</option>
                                    <option>Popularity</option>
                                    <option>Newest First</option>
                                </select>
                            </div>
                            <div className={styles.filterItem}>
                                <label>Category</label>
                                <select>
                                    <option>Electronics</option>
                                    <option>Fashion</option>
                                    <option>Home & Furniture</option>
                                    <option>Books</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FiltersAndSorting;
